class SophiAPI {
    constructor(apiConfig, http) {
        const { siteInfo } = apiConfig;
        const { storeId } = siteInfo;
        this.apiConfig = apiConfig;
        this.http = http;
        this.path = `/wcs/resources/store/${storeId}/sophi/sophiserpresult`;
    }

    async getSophi(query = '', timeoutSeconds) {
        try {
            const { data } = await this.http.get(this.path, {
                ...(Number.isFinite(timeoutSeconds) && timeoutSeconds > 0
                    ? {
                          timeout: timeoutSeconds * 1000,
                      }
                    : {}),
                ...(typeof query === 'string' && {
                    params: {
                        query,
                    },
                }),
            });
            const { success, preemptive_queries, message } = data || {};
            return { success, preemptive_queries, message };
        } catch (e) {
            return { failedRequest: true };
        }
    }
}

export default SophiAPI;
